// Helpers used across finance pages.
export const formatTRY = (v) => {
    const n = Number(v || 0);
    return `₺${n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatDate = (s) => {
    if (!s) return "—";
    try { return new Date(s).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" }); } catch { return s; }
};

export const PARTY_TYPE_LABELS = {
    customer: "Müşteri",
    hotel: "Otel",
    agency: "Acente",
    staff: "Personel",
    supplier: "Tedarikçi",
    other: "Diğer",
};

export const PARTY_TYPE_COLORS = {
    customer: "bg-sky-100 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300",
    hotel: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
    agency: "bg-violet-100 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300",
    staff: "bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300",
    supplier: "bg-rose-100 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300",
    other: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
};

export const CATEGORY_LABELS = {
    booking_payment: "Müşteri Tahsilatı",
    refund: "Müşteri İadesi",
    commission: "Acente Komisyonu",
    supplier_payment: "Tedarikçi Ödemesi",
    expense: "Gider",
    tax: "Vergi",
    transfer: "Transfer",
    adjustment: "Düzeltme",
    insurance: "Sigorta",
    opening: "Açılış",
};

export const CATEGORY_COLORS = {
    booking_payment: "text-emerald-600 dark:text-emerald-400",
    refund: "text-rose-600 dark:text-rose-400",
    commission: "text-violet-600 dark:text-violet-400",
    supplier_payment: "text-amber-600 dark:text-amber-400",
    expense: "text-rose-600 dark:text-rose-400",
    tax: "text-orange-600 dark:text-orange-400",
    transfer: "text-sky-600 dark:text-sky-400",
    adjustment: "text-slate-600 dark:text-slate-400",
};

export const METHOD_LABELS = {
    cash: "Nakit",
    bank_transfer: "Havale/EFT",
    credit_card: "Kredi Kartı",
    virtual_pos: "Sanal POS",
    card_reversal: "Kart İptali",
    other: "Diğer",
};

export const REFUND_STATUS_LABELS = {
    pending: "Onay Bekliyor",
    approved: "Onaylandı",
    processed: "İade Edildi",
    rejected: "Reddedildi",
};

export const REFUND_STATUS_COLORS = {
    pending: "bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300",
    approved: "bg-sky-100 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300",
    processed: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
    rejected: "bg-rose-100 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300",
};
